import {actions} from '../constants/app_constants.js';
import i18n from '../utils/localizations.jsx';

const initialState = {
    appLanguage: "",//i18n.language,
    deviceTypes: [],
    ioTypes: [],
    ioActionTypes: [],
    appModulesAccess: [],
    appFieldsAccess: [],
    ready: false,
    loading: false,
    error: {}
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case actions.START_REQUEST:
    {
        return {
            ...state,
            loading: true
        };
            }
        case actions.GET_APP_SETTINGS:
        {
            return {
                ...state,
                deviceTypes: action.appSettings.deviceTypes,
                ioTypes: action.appSettings.ioTypes,
                ioActionTypes: action.appSettings.ioActionTypes,
                appModulesAccess: action.appSettings.appModulesAccess,
                appFieldsAccess: action.appSettings.appFieldsAccess,
                loading: false,
                ready: true
            };
        }
        case actions.HANDLE_ERROR:
    {
        return {
            ...state,
            error: action.error,
            loading: false
        };
    }
        case actions.CLEAR_ERROR:
    {
        return {
            ...state,
            error: {}
        };
    }
        case actions.END_REQUEST:
    {
        return {
            ...state,
            loading: false
        };
            }
        case actions.CHANGE_APP_LANGUAGE:
    {
        return {
            ...state,
            appLanguage: action.language,
            loading: false
        };
    }
    default:
        return state;
    }
};